import React, { useState, useEffect } from 'react';
import Card from 'screens/shared/card-basic';
import Icon from 'screens/shared/icon';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { MonitoringAction } from 'models';
import Utils from 'screens/shared/utilities';

export default ({
  onChange = null,
  error = '',
  returnOnlyId = true,
  active = false,
  value = [],
}) => {
  const { [ACTIONS_TYPES.MONITORING.ACTION.GET_ALL]: monitoringActions = [] } = useSelector((e) => e);

  const [items, setItems] = useState([]);
  const [isActive, setIsActive] = useState(active);

  useEffect(() => {
    if (monitoringActions.length) {
      if (value.length) {
        setItems(monitoringActions.map((item) => {
          if (value.includes(item.id)) {
            item.isSelected = true;
          }

          return item;
        }));
      } else {
        setItems(monitoringActions);
      }
    }
    // eslint-disable-next-line
  }, [monitoringActions]);

  useEffect(() => {
    actions.monitoring.action.getAll();
  }, []);

  const onItemSelect = (item) => {
    item.isSelected = !item.isSelected;
    const index = items.findIndex(({ id }) => id === item.id);
    items[index] = item;
    setItems([...items]);

    const selectedItems = items.filter(({ isSelected }) => isSelected);

    if (returnOnlyId) {
      onChange(selectedItems.map(({ id }) => id));
    } else {
      onChange(selectedItems);
    }
  };

  return (
    <>
      <div className="image-selector" style={error ? { border: '1px solid var(--color-danger)' } : {}}>
        {!isActive ? (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          <p style={{ margin: 0, padding: 13, cursor: 'pointer' }} onClick={() => setIsActive(true)}>
            Select Actions
            <Icon name="sort" style={{ float: 'right' }} />
          </p>
        ) : (
          <>
            <p style={{ margin: 0, padding: '15px 15px 0 15px' }}>
              Select Actions (Can choose multile)
              <Icon name="sort" style={{ float: 'right' }} onClick={() => setIsActive(false)} />
            </p>

            <hr style={{ margin: '10px 12px 5px 12px' }} />

            <div className="cards">
              {monitoringActions.map((action) => {
                const {
                  id = '', properties = {}, isSelected = false,
                } = new MonitoringAction(action);
                const { name = '', typeProperties = {} } = properties;
                const { emailTo = '' } = typeProperties;

                return (
                  <Card
                    key={id}
                    className={!!isSelected && 'selected'}
                    onClick={() => onItemSelect(action)}
                    icon="paper-plane"
                    title={name}
                    details={emailTo}
                    buttons={[]}
                    isArrow={false}
                  />
                );
              })}
              {!items.length && <Utils.NoData />}
            </div>
          </>
        )}
      </div>
      { error && <span style={{ color: 'var(--color-danger)' }}>{error}</span>}
    </>
  );
};
